export const tokenName="token"
export const role="token1"
export const id="token2"
export const fullname="token3"
export const email="token4"